module.exports = __webpack_public_path__ + "img/capa2.13d39118.webp";